import { InjectionToken } from "@angular/core";

// Outside the generated client, which imports it from here, so app.module can provide it eagerly (PROXY-7).
export const FINANCIAL_API_BASE_URL = new InjectionToken<string>("FINANCIAL_API_BASE_URL");
